import { motion } from "framer-motion";

import SearchResultsContent from "./search-results-content";
import { variant } from "../../../animations";

const SearchResults = () => {
  return (
    <motion.div
      variants={variant}
      initial='hidden'
      animate='visible'
      className='search-results'>
      <SearchResultsContent />
    </motion.div>
  );
};

export default SearchResults;
